export const typeMapping = {
  text: 'icon-link-outline',
  // powerbi: 'icon-powerbi-outline',
  powerbi: 'icon-powerBI-outline-custom',
  textContainer: 'icon-notebook-outline-custom',
  pdf: 'icon-pdf-outline',
  image: 'icon-image-outline',
};

export const typeMapping_list = {
  text: 'icon-link-custom',
  // powerbi: 'icon-powerbi-outline',
  powerbi: 'icon-powerBI-outline-custom-1',
  textContainer: 'icon-notebook-outline-custom-1',
  pdf: 'icon-pdf-outline',
  image: 'icon-image-outline',
};
